<template>
  <div class="card">
    <div class="list list--nested">
      <div class="list__header py-2 pr-2 pl-6 flex justify-between items-baseline">
        <div class="text-gray-700 capitalize">
          {{ $te('targeting') ? $t('targeting') : 'targeting' }}
        </div>
      </div>
      <div class="list__body">
        <div class="list__item p-6 space-y-2">
          <span class="text-sm text-gray-700 capitalize">
            {{ $te('targetType') ? $t('targetType') : 'targetType' }}
          </span>
          <div>
            {{ campaign.target }}
          </div>
        </div>
        <div class="list__item p-6 space-y-2">
          <span class="text-sm text-gray-700 capitalize">
            {{ $te('target') ? $t('target') : 'target' }}
            {{ $te('in') ? $t('in') : 'in' }}
            {{ $te(campaign.target) ? $t(campaign.target) : campaign.target }}
          </span>
          <div v-if="campaign.result">
            {{ campaign.result | float }}
          </div>
          <div v-else>
            {{ $te('notSet') ? $t('notSet') : 'not set' }}
          </div>
        </div>
        <div class="list__item p-6 space-y-2">
          <span class="text-sm text-gray-700 capitalize">
            {{ $te('targetPrice') ? $t('targetPrice') : 'price' }}
            {{ $te('per') ? $t('per') : 'per' }}
            {{ campaign.target | singular }}
          </span>
          <div v-if="campaign.pricePerResult">{{ campaign.pricePerResult | float }} &euro;</div>
          <div v-else>
            {{ $te('notSet') ? $t('notSet') : 'not set' }}
          </div>
        </div>
        <div class="list__item p-6 space-y-2">
          <span class="text-sm text-gray-700 capitalize">
            {{ $te('adBudget') ? $t('adBudget') : 'ad budget' }}
          </span>
          <div v-if="campaign.price">{{ campaign.price | float }} &euro;</div>
          <div v-else>
            {{ $te('notSet') ? $t('notSet') : 'not set' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CampaignPricing',
  props: {
    campaign: {
      type: Object,
      required: true,
    },
  },
};
</script>
